import axios from 'axios';
import { authorizereqUrl, environment, leadSquaredGetUserApi, paymentBaseUrl, secrectSettlementUrl, reqBody, subscriptionStatusCheck, verifyUsers, leadSquaredUrl, productMainUrl, linkTrackerUrl, baseUrl, allowUserScriptUrl, centrelLoggerUrl } from '../constant';

class DataService {
    productDataCache = null;
    paymentConfigCache = null;
    paymentMenthodCache = null;
    paymentGatewayCache = null;
    checkPaymentStatusCache = null;
    leadSquaredCache = null;
    allowUserScriptCache = null;
    afterPaymentInitialLeadSquaredCache = null;
    stoxboxSubscriptionStatusCache = null;
    cacheUserAuthorizeData = null;
    loading = true;
    userVerifyApiCache = new Map();
    verifyUserPromise = null;
    isUserVerifyAPIProcesing = false;


    productData = async (url) => {
        if (this.productDataCache) {
            return this.productDataCache;
        }
        if (this.isFetching) {
            // Another request is already in progress, wait for it to complete.
            await this.fetchingPromise;
            return this.productDataCache;
        }

        try {
            this.isFetching = true;
            this.fetchingPromise = axios.get(url);
            const response = await this.fetchingPromise;
            this.productDataCache = response.data;
            return response.data;
        } catch (error) {
            this.catchError(`Error occured in product data:${error}`, "");
        } finally {
            this.isFetching = false;
        }
    }



    paymentConfig = async (url) => {
        if (this.paymentConfigCache) {
            return this.paymentConfigCache;
        }
        try {
            const response = await axios({
                method: "get",
                url: `${url}/payment-config/${environment}`,
            });
            this.paymentConfigCache = response;
            return response;
        } catch (error) {
            this.catchError(`Error occured in payment config:${error}`, "");
        }
    }

    paymentMenthod = async (url) => {
        if (this.paymentMenthodCache) {
            return this.paymentMenthodCache;
        }
        try {
            const response = await axios.get(`${url}/payment-config/${environment}`);
            this.paymentMenthodCache = response;
            return response;
        } catch (error) {
            this.catchError(`Error occured in payment config:${error}`, "");
        }
    }

    paymentGateway = async (paymentUrls, initialState) => {
        try {
            const response = await axios({
                method: "post",
                url: paymentUrls,
                data: initialState,
            });
            this.paymentGatewayCache = response.data;
            return response.data;
        } catch (error) {
            this.centralLogger(initialState, error, "500");
        }
    }

    leadSquared = async (webEngageUrl, webEngageReqBody) => {
        if (this.leadSquaredCache) {
            return this.leadSquaredCache;
        }

        if (this.isLeadSquaredFetching) {
            await this.leadSquaredFetchingPromise;
            return this.leadSquaredCache;
        }

        try {
            this.isLeadSquaredFetching = true;
            this.leadSquaredFetchingPromise = axios({
                method: "post",
                url: webEngageUrl,
                data: webEngageReqBody,
            });
            const response = await this.leadSquaredFetchingPromise;
            this.leadSquaredCache = response.data;
            return response.data;
        } catch (error) {
            this.centralLogger(webEngageReqBody, error, "500");
        } finally {
            this.isLeadSquaredFetching = false;
        }
    }

    leadSquaredUserData = async (phonenumber) => {
        try {
            const response = await axios.get(`${leadSquaredGetUserApi}${phonenumber}`);
            return response.data;
        } catch (error) {
            this.catchError(`Error occured in payment config:${error}`, "");
            this.centralLogger(phonenumber, error, "500");
        }
    }


    checkPaymentStatus = async (params, url) => {
        
        try {
            const response = await axios.get(
                `${url}/api/payment-status/${params.gateway}/${params.method}/${params.id}`,
            );
            return response.data;
        } catch (error) {
            this.centralLogger(params, error, "500");
        }
    }

    stoxboxSubscriptionStatus = async (clientCode, planId,url) => {

        try {
            const apiUrl = url.replace('${clientCode}', clientCode).replace('${planId}', planId);
            const response = await axios.get(apiUrl);
            return response.data;
        } catch (error) {
            this.centralLogger(`${clientCode + "" + planId}`, error, "500");
        }
    }

    secretSettlementAmount = async (secretSettlementBody,url) => {
        try {
            const response = await axios({
                method: "post",
                url: secrectSettlementUrl,
                data: secretSettlementBody,
            });
            return response.data;
        } catch (error) {
            this.centralLogger(secretSettlementBody, error, "500");
        }
    }

    updateOrderId = async (updateOrderIdBody) => {
        try {
            const response = await axios({
                method: "post",
                url: secrectSettlementUrl,
                data: updateOrderIdBody,
            });
            return response.data;
        } catch (error) {
            this.centralLogger(updateOrderIdBody, error, "500");
        }
    }

    linkTracker = async (linkTrackerBody,url) => {
        try {
            const response = await axios({
                method: "post",
                url: url,
                data: linkTrackerBody,
            });
            return response.data;
        } catch (error) {
            this.centralLogger(linkTrackerBody, error, "500");
        }
    }

    isFamilyUser = async (mobileNo,authorizereqUrl,verifyUrl) => {
        try {
          const verifiedUserData = await this.getVerifyUserData(mobileNo,authorizereqUrl,verifyUrl);
        //   console.log("user data : ",verifiedUserData)
          let isFam = verifiedUserData.length > 1;
          let userResult;
          if(isFam === false) {
            userResult = {
                family: isFam,
                clientCode:verifiedUserData[0].code
              }
          } else {
            userResult = {
                family: isFam,
                clientCode:""
              }
          }
          return userResult;
        } catch (error) {
          console.error('Error verifying user data:', error);
          return false; // Default to false if there’s an error
        }
      };

    getVerifyUserData = async (mobile,authorizereqUrl,verifyUrl) => {
        if (this.userVerifyApiCache.has(mobile)) {
            return Promise.resolve(this.userVerifyApiCache.get(mobile));
        }
        else if (this.isUserVerifyAPIProcesing) {
            return this.verifyUserPromise;
        }
        else {
            this.verifyUserPromise = new Promise(async (resolve, reject) => {
                this.isUserVerifyAPIProcesing = true;
                try {
                    this.loading = true;
                    const authorizeToken = await this.authorizeUserRequest(authorizereqUrl);
                    const response = await fetch(verifyUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authorizeToken.data.id_token}`,
                        },
                        body: JSON.stringify({
                            taskcode: "101",
                            entitycode: "502",
                            body: {
                                mob: mobile,
                            },
                        }),
                    });
                    this.loading = false;
                    const verifiedUserData = await response.json();
                    // let responseAllowUserScript;
                    // let isValidCode = false;
                    // responseAllowUserScript = await axios.get(allowUserScriptUrl);
                    // if (verifiedUserData && verifiedUserData.length > 0) {
                    //     const isMobileIncluded = responseAllowUserScript && responseAllowUserScript.data.includes(mobile);
                    //     const isClientCodeIncluded = responseAllowUserScript && responseAllowUserScript.data.includes(clientCode);
                    //     isValidCode = isMobileIncluded || isClientCodeIncluded;
                    // } else if (clientCode) {
                    //     isValidCode = responseAllowUserScript && responseAllowUserScript.data.includes(clientCode);
                    // } else {
                    //     isValidCode = false;

                    // }
                    // return {
                    //     loading: this.loading,
                    //     isValidCode: isValidCode,
                    //     result: verifiedUserData
                    // };
                    this.userVerifyApiCache.set(mobile, verifiedUserData);
                    resolve(verifiedUserData);
                } catch (error) {
                    reject(error);
                    this.centralLogger(`${mobile + ""}`, error, "500");
                }
                this.isUserVerifyAPIProcesing = false;
            })
            return this.verifyUserPromise;
        }
    };

    leadSquaredDataSave = async (leadSquaredData, initialState) => {
        const leadSquaredBody = [];
        function addAttributeIfDefined(attribute, value) {
            if (attribute && value && value.trim() !== "" && attribute && value && value.trim().toLowerCase() !== "null") {
                leadSquaredBody.push({
                    "Attribute": attribute,
                    "Value": value
                });
            }
        }

        if (initialState.client_name) {
            addAttributeIfDefined("FirstName", initialState.client_name);
        } else {
            const phoneNumber = initialState.client_client_mobile;
            const response = await this.leadSquaredUserData(phoneNumber);
            if (response.length > 0 && response[0].FirstName && response[0].FirstName.trim().toLowerCase() !== "null") {
                addAttributeIfDefined("FirstName", response[0].FirstName);
            }
        }

        addAttributeIfDefined("EmailAddress", initialState.client_email);
        addAttributeIfDefined("Phone", initialState.client_mobile);
        addAttributeIfDefined("mx_City", initialState.city);
        addAttributeIfDefined("Source", leadSquaredData.utm_source ? leadSquaredData.utm_source : "paymentGateway");
        addAttributeIfDefined("mx_UTMSource", leadSquaredData.utm_source ? leadSquaredData.utm_source : "paymentGateway");
        addAttributeIfDefined("SourceCampaign", leadSquaredData.utm_campaign || "");
        addAttributeIfDefined("SourceMedium", leadSquaredData.utm_medium || "");
        addAttributeIfDefined("mx_Ad_Set", leadSquaredData.utm_adset || "");
        addAttributeIfDefined("mx_Ad_Group", leadSquaredData.utm_adgroup || "");
        addAttributeIfDefined("mx_Ads", leadSquaredData.utm_ads || "");
        addAttributeIfDefined("mx_CommSource", leadSquaredData.commSource || "");
        addAttributeIfDefined("utm_content", leadSquaredData.utm_content || "");
        addAttributeIfDefined("ProspectID", "");
        addAttributeIfDefined("SearchBy", "Phone");
        addAttributeIfDefined("RelatedCompanyId", "");
        try {
            const val = await this.leadSquared(leadSquaredUrl, leadSquaredBody);
            return val?.Message.RelatedId;
        } catch (error) {
            this.centralLogger(initialState, error, "500");
        }
    }

    allowUser = async (clientCode,url) => {
        const allowUserResult = await axios.get(`${url}/api/allowed-user-check?clientCode=${clientCode}`);
        return allowUserResult.data;
    }

    centralLogger = async (resBody, error, status) => {
        const reqBody = {
            "service": "PaymentUI_UAT",
            "statuscode": error.response.status,
            "authenticationtoken": "JWT token",
            "inputdata": resBody, error,
            "timetaken": "10"
        }
        console.log(reqBody, "CALLED")
        const centrelLoggerResponse = await axios.get(centrelLoggerUrl,);
        // return centrelLoggerResponse.data;
    }

    catchError = async (errorVal, clientCode) => {
        try {
            const reqObj = {
                taskcode: "102",
                entitycode: "862",
                body: {
                    service: "ReactUI",
                    clientCode: clientCode,
                    errorBody: errorVal
                }
            }
            await axios.post(`${baseUrl}/stxsubs/noauth`, reqObj).then((val) => {
                // console.log(val)
            }).catch((error) => {
                console.log(`Error occurred in verify catch error:${error}`, "");
            })

        } catch (error) {
            this.centralLogger(`${clientCode + ""}`, error, "500");
        }
    }

    authorizeUserRequest = async (url) => {
        try {
            if (this.cacheUserAuthorizeData && this.cacheUserAuthorizeData.data && this.cacheUserAuthorizeData.data.id_token) {
                return this.cacheUserAuthorizeData;
            }
            const response = await axios.post(url, reqBody);
            this.cacheUserAuthorizeData = response;
            return response;
        } catch (error) {
             this.centralLogger(url, error);
            throw error;
        }
    }

    callGTMStatus = (email) => {
        window.dataLayer.push({
            'event': 'formSubmit.Success',
            "email": email
        });
    }

}

export default new DataService();
